"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySchema = exports.WidgetSchema = exports.PluginSchema = exports.ADSchema = exports.KumodiSchema = exports.ADAuthSchema = exports.OktaSchema = exports.CognitoSchema = exports.InstanceSchema = exports.keywordManagement = exports.AppConfigSchema = exports.QuickReplyConfigurationSchema = exports.LabelDataSchema = exports.ChannelSchema = exports.OutboundNumberMappings = exports.OnHangUp = exports.BrandSchema = exports.FeatureSchema = exports.AthenaSchema = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.AthenaSchema = (0, yup_1.object)({
    database: (0, yup_1.string)().notRequired(),
    results: (0, yup_1.string)().required(),
    roleName: (0, yup_1.string)().notRequired(),
    accountID: (0, yup_1.string)().required(),
    externalID: (0, yup_1.string)().required(),
    region: (0, yup_1.string)().notRequired(),
});
exports.FeatureSchema = (0, yup_1.object)({
    ID: (0, yup_1.string)().required(),
    config: (0, yup_1.mixed)().notRequired(),
});
exports.BrandSchema = (0, yup_1.object)({
    name: (0, yup_1.string)().required(),
    label: (0, yup_1.string)().required(),
});
exports.OnHangUp = (0, yup_1.object)({
    transfer: (0, yup_1.boolean)().required(),
    transferName: (0, yup_1.string)().required(),
});
exports.OutboundNumberMappings = (0, yup_1.object)({
    number: (0, yup_1.string)().required(),
    mapping: (0, yup_1.string)().required(),
});
exports.ChannelSchema = (0, yup_1.object)({
    label: (0, yup_1.string)().required(),
    value: (0, yup_1.string)().required(),
});
exports.LabelDataSchema = (0, yup_1.object)({
    label: (0, yup_1.string)().required(),
    data: (0, yup_1.string)().required(),
});
exports.QuickReplyConfigurationSchema = (0, yup_1.object)({
    defaultFacia: (0, yup_1.string)().required(),
    defaultLanguage: (0, yup_1.string)().required(),
});
exports.AppConfigSchema = (0, yup_1.object)({
    afterCallWorkInitialTimeoutSeconds: (0, yup_1.number)().required(),
    autoAnswerCallbacks: (0, yup_1.boolean)().notRequired(),
    disableCCP: (0, yup_1.boolean)().notRequired(),
    disallowedStates: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    disallowedConferenceDestinations: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    disallowConferencing: (0, yup_1.boolean)().notRequired(),
    hideExtendACW: (0, yup_1.boolean)().notRequired(),
    agentExpiry: (0, yup_1.number)().notRequired(),
    autoPostReportIssue: (0, yup_1.boolean)().notRequired(),
    callHistoryPeriodInHours: (0, yup_1.number)().notRequired(),
    contactAttributes: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    afterCallWorkPlayAlertTone: (0, yup_1.boolean)().notRequired(),
    defaultNumberDPAPassesRequiredForPass: (0, yup_1.number)().notRequired(),
    noPostback: (0, yup_1.boolean)().notRequired(),
    failedConnectCustomerToPreviousState: (0, yup_1.boolean)().notRequired(),
    onHangUp: exports.OnHangUp.notRequired(),
    hideMuteButton: (0, yup_1.boolean)().notRequired(),
    muteOnHold: (0, yup_1.boolean)().notRequired(),
    outboundNumberMappings: (0, yup_1.array)(exports.OutboundNumberMappings).notRequired(),
    channels: (0, yup_1.array)(exports.ChannelSchema).notRequired(),
    subChannels: (0, yup_1.array)(exports.ChannelSchema).notRequired(),
    languages: (0, yup_1.array)(exports.LabelDataSchema).notRequired(),
    facias: (0, yup_1.array)(exports.LabelDataSchema).notRequired(),
    quickReplyManagment: exports.QuickReplyConfigurationSchema.notRequired(),
    sendWholeConversationInReplyEmail: (0, yup_1.boolean)().notRequired(),
    allowFramedSoftphone: (0, yup_1.boolean)().notRequired()
});
//TODO: rework this to be one property
const CallRecordingConfig = (0, yup_1.object)({
    bucketName: (0, yup_1.string)().required(),
    prefix: (0, yup_1.string)().required(),
});
const CallTranscriptionConfig = (0, yup_1.object)({
    bucketName: (0, yup_1.string)().required(),
});
const CallComprehensionConfig = (0, yup_1.object)({
    bucketName: (0, yup_1.string)().required(),
});
const CallWaveformConfig = (0, yup_1.object)({
    bucketName: (0, yup_1.string)().required(),
});
const MSTeamsConfig = (0, yup_1.object)({
    bucketName: (0, yup_1.string)().required(),
});
exports.keywordManagement = (0, yup_1.object)({
    primary: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    secondary: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    vocabularyVersion: (0, yup_1.number)().required().default(1),
}).notRequired();
const Settings = (0, yup_1.object)({
    keywordManagement: exports.keywordManagement,
});
exports.InstanceSchema = (0, yup_1.object)({
    ccpURL: (0, yup_1.string)().required(),
    ID: (0, yup_1.string)().required(),
    key: (0, yup_1.string)().required(),
    name: (0, yup_1.string)().required(),
    transferFlowID: (0, yup_1.string)().notRequired(),
    roleName: (0, yup_1.string)().notRequired(),
    loginRoleName: (0, yup_1.string)().notRequired(),
    accountID: (0, yup_1.string)().required(),
    externalID: (0, yup_1.string)().required(),
    region: (0, yup_1.string)().notRequired(),
    allocateOutbound: (0, yup_1.boolean)().notRequired(),
    esHost: (0, yup_1.string)().notRequired(),
    daxEndpoint: (0, yup_1.string)().notRequired(),
    callRecordingConfig: CallRecordingConfig.notRequired(),
    callTranscriptionConfig: CallTranscriptionConfig.notRequired(),
    callComprehensionConfig: CallComprehensionConfig.notRequired(),
    msTeamsConfig: MSTeamsConfig.notRequired(),
    callWaveformConfig: CallWaveformConfig.notRequired(),
    settings: Settings.notRequired().default(undefined),
});
exports.CognitoSchema = (0, yup_1.object)({
    domain: (0, yup_1.string)().required(),
    client_id: (0, yup_1.string)().required(),
    usernameMapping: (0, yup_1.string)().notRequired(),
    userPoolId: (0, yup_1.string)().required(),
    region: (0, yup_1.string)().required(),
    type: (0, yup_1.mixed)().oneOf(['in_app', 'redirect']).notRequired(),
    tokenMFA: (0, yup_1.boolean)().notRequired(),
});
exports.OktaSchema = (0, yup_1.object)({
    domain: (0, yup_1.string)().required(),
    clientId: (0, yup_1.string)().required(),
});
exports.ADAuthSchema = (0, yup_1.object)({
    authority: (0, yup_1.string)().required(),
    clientId: (0, yup_1.string)().notRequired(),
    redirectUri: (0, yup_1.string)().notRequired(),
});
exports.KumodiSchema = (0, yup_1.object)({
    clientID: (0, yup_1.string)().required(),
    apiKey: (0, yup_1.string)().required(),
});
exports.ADSchema = (0, yup_1.object)({
    auth: exports.ADAuthSchema.required(),
    clientSecret: (0, yup_1.string)().notRequired(),
    type: (0, yup_1.mixed)().oneOf(['code', 'implicit', 'openid']).notRequired(),
    usernameMapping: (0, yup_1.string)().notRequired(),
    usernameToken: (0, yup_1.mixed)().oneOf(['access_token', 'id_token']).notRequired(),
});
exports.PluginSchema = (0, yup_1.object)({
    defaultHidden: (0, yup_1.boolean)().notRequired(),
    name: (0, yup_1.string)().required(),
    src: (0, yup_1.string)().required(),
    title: (0, yup_1.string)().required(),
    type: (0, yup_1.mixed)().oneOf(['call', 'default', 'contact-log', 'DPA', 'nav']),
    auth: (0, yup_1.mixed)().notRequired(),
    roles: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
    view: (0, yup_1.string)().notRequired(),
    origin: (0, yup_1.string)().notRequired(),
    useAttributesToUpdateSrc: (0, yup_1.boolean)().notRequired()
});
exports.WidgetSchema = (0, yup_1.object)({
    default: (0, yup_1.boolean)().notRequired(),
    name: (0, yup_1.string)().required(),
    type: (0, yup_1.string)().required(),
    whitelist: (0, yup_1.array)((0, yup_1.string)()).notRequired(),
});
exports.CompanySchema = model_schema_1.Schema.shape({
    instances: (0, yup_1.array)(exports.InstanceSchema).min(1).required(),
    appConfig: exports.AppConfigSchema.required(),
    name: (0, yup_1.string)().required(),
    groupName: (0, yup_1.string)().notRequired(),
    logoURL: (0, yup_1.string)().notRequired(),
    plugins: (0, yup_1.array)(exports.PluginSchema).notRequired(),
    athena: exports.AthenaSchema.default(undefined).notRequired(),
    identityManagement: (0, yup_1.mixed)()
        .oneOf(['ad', 'connect', 'cognito', 'okta'])
        .default('connect')
        .notRequired(),
    callProvider: (0, yup_1.mixed)().oneOf(['connect', 'kumodi']).default('connect').notRequired(),
    cognito: exports.CognitoSchema.default(undefined).notRequired(),
    okta: exports.OktaSchema.default(undefined).notRequired(),
    ad: exports.ADSchema.default(undefined).notRequired(),
    kumodi: exports.KumodiSchema.default(undefined).notRequired(),
    whitelistIPSetID: (0, yup_1.string)().notRequired(),
    widgets: (0, yup_1.array)(exports.WidgetSchema).notRequired(),
    features: (0, yup_1.array)(exports.FeatureSchema).default([]),
    brands: (0, yup_1.array)(exports.BrandSchema).notRequired()
});
